import { useSelector } from 'react-redux';
import { getToken } from '../../selectors/global';

const useConnect = () => ({
  token: useSelector(getToken),
});

export default useConnect;
